/**
 * @sw-package b2b
 */

import Plugin from 'src/plugin-system/plugin.class';

export default class B2bQuoteItemPlugin extends Plugin {
    init(): void {
        this._expirationDate = this.el.querySelector(this.options.selectors.expirationDate);
        this._status = this.el.querySelector(this.options.selectors.status);
        this._expiredStatus = this.el.querySelector(this.options.selectors.expiredStatus);

        this.renderExpiredLabel();
    }

    renderExpiredLabel(): void {
        const expirationDate = this._expirationDate?.attributes[this.options.attributes.dataExpiration]?.value;
        if (!expirationDate) {
            return;
        }

        const isExpired = new Date(expirationDate) < Date.now();
        if (isExpired && this._expiredStatus) {
            this._expiredStatus.classList.remove('d-none');
            this._status?.classList.add('d-none');
            return;
        }
    }
}
